import { render, staticRenderFns } from "./OlivinCalc.vue?vue&type=template&id=3893cafc&"
import script from "./OlivinCalc.vue?vue&type=script&lang=js&"
export * from "./OlivinCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports